<script setup>
import { computed } from 'vue';
import AppMenu from './AppMenu.vue';
import { useLayout } from '@/layout/composables/layout';

const { layoutConfig, layoutState } = useLayout();

const sidebarClass = computed(() => ({
	'translate-x-0': layoutState.staticMenuMobileActive,
	'-translate-x-full': !layoutState.staticMenuMobileActive,
	'lg:translate-x-0': layoutConfig.menuMode === 'static' && !layoutState.staticMenuDesktopInactive,
	'lg:-translate-x-[calc(100%+2rem)]': (layoutConfig.menuMode === 'static' && layoutState.staticMenuDesktopInactive) || (layoutConfig.menuMode === 'overlay' && !layoutState.overlayMenuActive),
	'lg:!translate-x-0': layoutConfig.menuMode === 'overlay' && layoutState.overlayMenuActive
}));
</script>

<template>
	<div
		class="layout-sidebar fixed left-0 top-0 z-[999] h-screen w-80 select-none overflow-y-auto rounded-r-border bg-[var(--egs-content-background)] px-6 py-2 shadow-dropdown transition-transform duration-300 lg:left-8 lg:top-24 lg:h-[calc(100vh-8rem)] lg:rounded-border lg:shadow-none"
		:class="sidebarClass"
	>
		<app-menu />
	</div>
</template>
